import dayjs from "dayjs";
import { useShopStore } from "../modules/core/store/shop";

export default defineNuxtRouteMiddleware((to, from) => {
  const shopStore = useShopStore();
  const expireDate = shopStore.expireDate;
  const addDayToExpireDate = shopStore.getExpiredDate; // 1 day and 7 hours

  // /sentry-test เป็นหน้า diagnostics ต้องเข้าได้แม้ร้านหมดอายุ
  const allowedPaths = ["/topup/promptpay", "/sentry-test"];


  if (allowedPaths.some((path) => to.path.startsWith(path))) {
    return;
  }

  if (to.path.startsWith("/expired")) {
    return;
  }


  const currentDate = dayjs();
  

  if (expireDate && dayjs(addDayToExpireDate).isBefore(currentDate)) {
    if (!to.path.startsWith("/expired")) {
      return navigateTo(`/expired?storeId=${shopStore.storeId}`);
    }
  }
});
